import CongratulationsPage from "./CongratulationsPage";
export default CongratulationsPage;
